import { render } from "./Seat_A380.vue?vue&type=template&id=1882178e&scoped=true"
import script from "./Seat_A380.vue?vue&type=script&lang=js"
export * from "./Seat_A380.vue?vue&type=script&lang=js"

import "./Seat_A380.vue?vue&type=style&index=0&id=1882178e&lang=scss&scoped=true"

import exportComponent from "/opt/buildhome/repo/node_modules/vue-loader/dist/exportHelper.js"
const __exports__ = /*#__PURE__*/exportComponent(script, [['render',render],['__scopeId',"data-v-1882178e"]])

export default __exports__